module.exports = __webpack_public_path__ + "static/media/D929A227-DBE5-4E21-9D24-211263774070.d2ad814e.jpeg";